import AuthorizeSignIn from './login/authorizeSignIn';
import LogOutUser from './login/logout';
import RegisterNewUser from './login/register';
import ResetLostPassword from './login/resetLostPassword';
import DispenserStatus from './components/Dispensers/dispenser-status';
import { taxListTable, partnerListTable, customerListTable, userListTable, heartbeatListTable } from './components/Tables/table-index';
import DashboardTransactionsMain from './components/Tables/table-dashboard-transactions-main';
import TransactionTable from './components/Tables/table-transaction-main';
import CardListTable from './components/Tables/table-cardlist-main';
import CardGroupTable from './components/Tables/table-cardgroup-main';
import TerminalListTable from './components/Tables/table-terminallist-main';
import { formTerminal, formCustomer, formPortalUser, updateUserColorScheme, formCardGroups, formUserSettings, formTerminalCardGroup, formTaxTerminalCardGroup, postNewPartner, formCards,formTerminalTax, formAskFor, askForValidation } from './components/forms/form-index';
import { viewTransaction } from './components/transactions/view-transaction';
import SentryInit from './sentry';

/**
 * The main application function. This is the entry point for the application.
 * 
 * @returns void
 */
const app = async () => {
  const logout = document.querySelector('#aafp_log-out') as HTMLElement;

  await AuthorizeSignIn();
  await RegisterNewUser();
  ResetLostPassword();
  DispenserStatus();

  // function calls for tables and related functionalities
  DashboardTransactionsMain();
  TransactionTable();
  CardListTable();
  CardGroupTable();
  TerminalListTable();

  taxListTable();
  customerListTable();
  partnerListTable();
  heartbeatListTable();
  userListTable();
  viewTransaction();

  formTerminal();
  formCustomer();
  formPortalUser();
  updateUserColorScheme();
  formCardGroups();
  formUserSettings();
  formTerminalCardGroup();
  formTaxTerminalCardGroup();
  postNewPartner();
  formCards();
  formTerminalTax();
  formAskFor();
  askForValidation();

  SentryInit();

  if(!logout) return;
  logout.addEventListener('click', () => {
    LogOutUser();
  });
}

export {app};